import messages from './messages';

const middleware = [messages];

export default middleware;
